import React from "react";
import { Modal } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import CustomButton from "components/Common/buttons/CustomButton";
import meterLockedIcon from "assets/images/svg/meter-locked.svg";
import meterUnLockedIcon from "assets/images/svg/meter-unlock.svg";

const useStyles = makeStyles({
  root: {
    width: "400px!important",

    "& .ant-modal-header": {
      padding: "24px 24px 0 !important",
    },
  },
  centerTitle: {
    display: "flex",
    justifyContent: "center",
  },
  modalContent: {
    border: "1px solid rgba(0, 0, 0, 0.05)",
    borderLeft: "none",
    borderRight: "none",
    marginBottom: 24,
  },
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid #00000014",
    padding: 20,
    textAlign: "center",

    "& > img": {
      width: 70,
    },
  },
  buttonCenter: {
    display: "flex",
    justifyContent: "center",
  },
});

const MeterQuarantineModal = ({ onClose, serial, isRemove = false }) => {
  const classes = useStyles();

  return (
    <Modal
      open
      title={
        <div className={classes.centerTitle}>
          {isRemove ? "Meter removed from Quarantine" : "Meter is in Quarantine"}
        </div>
      }
      closable={false}
      onCancel={onClose}
      footer={[]}
      className={classes.root}
    >
      <div className={classes.imageContainer}>
        <img src={isRemove ? meterUnLockedIcon : meterLockedIcon} alt="MeterQuarantineModal" />
        <div className={classes.desc}>
          {isRemove
            ? `Meter ${serial || "-"} is now removed from quarantine and can be configured & tested!`
            : `Meter ${serial || "-"} cannot be tested or configured.`}
        </div>
      </div>

      <div className={classes.buttonCenter}>
        <CustomButton onClick={onClose} type="primary" size="small" text="Ok" />
      </div>
    </Modal>
  );
};

export default MeterQuarantineModal;
